import React, { memo } from 'react'
import { useStyles } from './styles'

interface InputCheckProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string
  type?: 'checkbox' | 'radio'
  value: string
  label: string
  name?: string
  register?: any
  error?: string
  className?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const InputCheckComponent: React.FC<InputCheckProps> = ({
  id,
  type = 'checkbox',
  value,
  label,
  name,
  register,
  error,
  className,
  onChange,
  ...rest
}) => {
  const { check } = useStyles()

  return (
    <div className={`${check} ${className || ''} ${error ? 'input-check--error' : ''}`}>
      <input
        id={id}
        type={type}
        value={value}
        {...(name && register ? register(name) : {})}
        onChange={onChange}
        {...rest}
      />
      <label htmlFor={id}>{label}</label>
      {error && <span className='custom-input__error'>{error}</span>}
    </div>
  )
}

export const InputCheck = memo(InputCheckComponent)
